import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { createContext, useContext } from "react";

function createSafeContext(errorMessage) {
  const Context = /*#__PURE__*/createContext(null);

  const useSafeContext = () => {
    const ctx = useContext(Context);

    if (ctx === null) {
      throw new Error(errorMessage);
    }

    return ctx;
  };

  const Provider = (_ref) => {
    let {
      children,
      value
    } = _ref;
    return /* @__PURE__ */jsxRuntimeExports.jsx(Context.Provider, {
      value,
      children
    });
  };

  return [Provider, useSafeContext];
}

export { createSafeContext };